"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    palette: palette,
    display: 'flex',
    fontSize: palette.tsSmall,
    lineHeight: palette.tlSmall,
    color: palette.tFilled,
    disabledColor: palette.tDisabled,
    selectedColor: palette.tAccent,
    fontWeight: palette.twNormal,
    balanceFontSize: palette.tsNormal,
    balanceLineHeight: palette.tlNormal,
    balanceColor: palette.tFilled,
    balanceFontWeight: palette.twSemi,
    selectedBalanceColor: palette.tAccent,
    numberColor: palette.tFilled,
    numberFontWeight: palette.twNormal,
    selectedNumberColor: palette.tAccent,
    nameColor: palette.tFilled,
    nameFontWeight: palette.twNormal,
    selectedNameColor: palette.tAccent,
    currencyFontSize: palette.tsNormal,
    currencyLineHeight: palette.tlNormal,
    currencyColor: palette.tFilled,
    currencyFontWeight: palette.twSemi,
    selectedCurrencyColor: palette.tAccent,
    width: 'auto',
    minWidth: 'auto',
    simple: {
      palette: palette,
      display: 'flex',
      fontSize: palette.tsNormal,
      lineHeight: palette.tlNormal,
      color: palette.tFilled,
      disabledColor: palette.tDisabled,
      fontWeight: palette.twNormal,
      selectedColor: palette.tAccent,
      balanceColor: palette.tFilled,
      balanceFontWeight: palette.twSemi,
      selectedBalanceColor: palette.tAccent,
      numberColor: palette.tInactive,
      numberFontWeight: palette.twNormal,
      selectedNumberColor: palette.tAccent,
      nameColor: palette.tFilled,
      nameFontWeight: palette.twNormal,
      selectedNameColor: palette.tAccent,
      currencyColor: palette.tFilled,
      currencyFontWeight: palette.twSemi,
      selectedCurrencyColor: palette.tAccent,
      width: 'auto',
      minWidth: 'auto'
    }
  };
}